import React from 'react';
import { Spinner } from './Spinner';
import { Skeleton } from './Skeleton';
import './States.css';

/**
 * LoadingState — идёт загрузка. Один текст «Загрузка…» вместо семи вариантов.
 *
 *   text     — «Загрузка…» / «Загружаем смену…»
 *   variant  — 'spinner' (по умолчанию) | 'rows' — скелетон строк таблицы/списка
 *   rows     — сколько строк скелетона (для variant="rows")
 *   compact  — строкой внутри таблицы/карточки
 */
export function LoadingState({ text = 'Загрузка…', variant = 'spinner', rows = 5, compact = false, className = '' }) {
  if (variant === 'rows') {
    return (
      <div className={`ui-loading-rows ${className}`} aria-busy="true" aria-label={text}>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} height={compact ? 28 : 36} width={`${100 - (i % 3) * 8}%`} />
        ))}
      </div>
    );
  }
  return (
    <div className={`ui-loading ${compact ? 'ui-loading--compact' : ''} ${className}`} role="status" aria-live="polite">
      <Spinner size={compact ? 'sm' : 'md'} />
      <span className="ui-loading__text">{text}</span>
    </div>
  );
}
